import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL, IMAGE_URL } from "../../Component/Baseurl"; 

const PaymentMake = ({ id, formId, submissionType, amount, paymentStatus, eventUniqueId }) => {
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
    
  const numericAmount = parseFloat(amount) || 0; // Convert amount to number
  const currency = "INR"; // Default currency

  // Load Razorpay script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => {
      setRazorpayLoaded(true);
      console.log("Razorpay script loaded successfully.");
    };

    script.onerror = () => {
      console.error("Failed to load Razorpay script.");
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Handle Razorpay Payment
  const handlePayment = async () => {
    if (!razorpayLoaded) {
      console.error("Razorpay script is not loaded yet.");
      return;
    }
  
    try {
      const requestData = {
        amount: numericAmount,
        currency: currency,
        id: id,
        formId: formId,
        submissionType: submissionType,
        eventUniqueId: eventUniqueId,
      };
  
      console.log("Request Data:", requestData);
  
      // Create payment order on the server
      const { data } = await axios.post(`${BASE_URL}razorpaypaymentForm`, requestData);
      console.log("Order Response:", data);
  
      if (!data.orderId) {
        console.error("Order ID not received from server.");
        return;
      }
  
      const { orderId, paymentMasterId } = data; // Extract orderId and paymentMasterId
  
      // Ensure Razorpay instance is created only if the script is loaded
      if (window.Razorpay) {
        const options = {
          key: "rzp_test_doqilf4l91yMln", // Replace with your Razorpay key_id
          amount: numericAmount * 100, // Convert to paise
          currency: currency,
          name: "Test Company",
          description: "Payment for Event",
          order_id: orderId,
          handler: async function (response) {
            console.log("Payment successful:", response);
  
            const paymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              paymentMasterId: paymentMasterId,
            };
  
            console.log("Payment Update Data:", paymentData);
  
            try {
              const statusResponse = await axios.post(`${BASE_URL}updatePaymentStatusForm`, paymentData);
              
              if (statusResponse.data.success) {
                  console.log("Payment Status Updated:", statusResponse.data);
                  
                  // Reload the page after a short delay for better UX
                  setTimeout(() => {
                      window.location.replace(window.location.href);
                  }, 1000);  // Delay 1 second before reloading
              } else {
                  console.error("Failed to update payment status:", statusResponse.data.message);
              }
          } catch (error) {
              console.error("Error while updating payment status or verifying payment:", error);
          }
          
          },
          prefill: {
            name: "John Doe",
            email: "johndoe@example.com",
            contact: "9876543210",
          },
          theme: {
            color: "#3399cc",
          },
        };
  
        const razorpay = new window.Razorpay(options);
        razorpay.open();
      } else {
        console.error("Razorpay instance not found.");
      }
    } catch (error) {
      console.error("Payment Error:", error.response ? error.response.data : error.message);
    }
  };
  
  
  return (
    <>
    
      <div className="container">
        <h3 className="my-4">Make Payment</h3>
        <p><strong>Form ID:</strong> {formId}</p>
        <p><strong>Submission Type:</strong> {submissionType}</p>
        <p><strong>Amount:</strong> ₹{amount}</p>
        <p><strong>Payment Status:</strong> {paymentStatus}</p>
        <p><strong>Event Unique ID:</strong> {eventUniqueId}</p>
        <button onClick={handlePayment} className="btn btn-primary">
          Pay Now
        </button>
      </div>
    
    </>
  );
};

export default PaymentMake;
